import React, { useState } from "react";
// import useForm from "../../hooks/useForm";
// import { useForm, Controller } from "react-hook-form";
import { Form } from "antd";

import { InputField, PrimaryButton, Card, Icons, CheckBox, Layout, Background, Typography, TextLink, PasswordField, Loader } from "../../components";
import { signupApi } from "../../api/index";
import { Helmet } from "react-helmet";

import "./RegistrationPage.scss";
import {
  EMPTY_REQUIRED_FIELD_MESSAGE,
  INVALID_EMAIL_MESSAGE,
  AGREE_TERMS_AND_CONDITIONS,
  INVALID_PASSWORD_MESSAGE,
  PASSWORD_REGEX,
  getPageTitle,
  UPPER_LETTER_CHECK_REGEX,
  LOWER_LETTER_CHECK_REGEX,
  NUMBER_CHECK_REGEX,
  DESCRIPTION,
  COMPANY_NAME_EXCEED_LIMIT_MESSAGE,
} from "../../constants/constants";
import useProfile from "../../hooks/useSetUserProfile";
import { REGISTRATION_PAGE_VIEW, SendEvent, SIGN_IN_LINK_CLICK, trackEvent } from "../../analytics";
import { useMemo } from "react";
import useFormSubmitDisable from "../../hooks/useFormSubmitDisable";

import { registerErrorMessage } from "../../constants/errorMessages";
import { useEffect } from "react";
import { useContext } from "react";
import { AnalyticsContext } from "../../storage/context";

// There are the required form fields, based on which register button will be hidden
const requiredFormFields = ["email", "password", "firstName", "companyName", "consent"];
const passwordRules = [
  {
    validator: (_, value) => {
      if (!value) {
        return Promise.reject(EMPTY_REQUIRED_FIELD_MESSAGE);
      }
      const errors = [];
      if (!UPPER_LETTER_CHECK_REGEX.test(value)) {
        errors.push("one uppercase letter");
      }
      if (!LOWER_LETTER_CHECK_REGEX.test(value)) {
        errors.push("one lowercase letter");
      }
      if (!NUMBER_CHECK_REGEX.test(value)) {
        errors.push("one number");
      }
      if (!(value.length >= 8)) {
        errors.push("at least 8 characters");
      }
      if (errors.length > 0) {
        let errorMessage = `The password should contain at least `;
        if (errors.length === 1) {
          if (errors[0].indexOf("8 characters") !== -1) errorMessage += "8 characters";
          else errorMessage += `${errors[0]} `;
        } else {
          errors.forEach((e, i) => {
            if (i === errors.length - 1) {
              errorMessage = errorMessage.slice(0, -2);
              errorMessage += ` and ${e}`;
            } else {
              errorMessage += `${e}, `;
            }
          });
        }
        return Promise.reject(errorMessage);
      }
      return Promise.resolve();
    },
  },
];

const exceedCharacterLimitHandler = (exceedCharacterLimitMessage) => {
  return {
    validator: (_, value) => {
      if (value && value.length > 100) {
        return Promise.reject(exceedCharacterLimitMessage);
      }
      return Promise.resolve();
    },
  };
};

export default function RegistrationPage() {
  const [formInstance] = Form.useForm();
  const { setUserProfile, verifyEmailIfNot } = useProfile();
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({
    email: false,
    password: false,
    errorMessage: "",
  });
  const disableSubmit = useFormSubmitDisable(formInstance, requiredFormFields);
  const phyllo_analytics = localStorage.getItem("phyllo_analytics");
  // const shouldDisableFormSubmit = () => {
  //   formInstance.isFieldTouched;
  // };

  const onSubmitRegistration = async () => {
    setLoading(true);
    const { firstName, companyName, email, password, lastName = "", consent } = formInstance.getFieldsValue();
    try {
      const response = await signupApi.signUpUser({
        firstName,
        companyName,
        email,
        password,
        lastName,
        consent,
      });
      setUserProfile(response);
      formInstance.resetFields();
      verifyEmailIfNot(response, email, password);
    } catch (e) {
      setErrors({
        email: true,
        errorMessage: registerErrorMessage[e.error_code],
      });
      setLoading(false);
    }
  };

  const sendUserAction = () => {
    trackEvent(SIGN_IN_LINK_CLICK);
  };

  const resetError = (name) => {
    setErrors({ ...errors, [name]: false });
  };

  useEffect(() => {
    trackEvent(REGISTRATION_PAGE_VIEW);
  }, []);
  return (
    <Background
      className="registration-page"
      leftLeaves
      // rightLeaves
      rightScratched
    >
      <div className="phyllo-feature-intro">
        <Icons.phyllo_icon_with_name name="phyllo_icon_with_name" />
        <div className="phyllo-feature-text">
          <Typography
            h1
            style={{
              marginTop: "47px",
              marginBottom: "40px",
              fontWeight: "600",
            }}
          >
            Access creator data with Phyllo APIs
          </Typography>
          <div>
            <IconListItem icon={<Icons.timer_flash_fill />} text="Integrate in 15 minutes" />
            <IconListItem icon={<Icons.earth_fill />} text="Explore Phyllo APIs" />
            {/* <IconListItem icon={<Icons.gift_fill />} text="250 connections free forever" /> */}
            <IconListItem icon={<Icons.customer_service_fill />} text="24 x 7 technical support" />
          </div>
        </div>
      </div>
      <div className="registration-parent-card-container">
        <Card className="registration-card-container">
          <Form form={formInstance}>
            <Typography h2 style={{ marginBottom: "32px", fontWeight: "600" }}>
              Create your account
            </Typography>
            <p className="error-message-text signin-error-text">{errors.errorMessage}</p>
            <div className="registration-name-container">
              <Form.Item
                rules={[
                  { required: true, message: EMPTY_REQUIRED_FIELD_MESSAGE },
                  // exceedCharacterLimitHandler(NAME_EXCEED_LIMIT_MESSAGE),
                ]}
                name="firstName"
              >
                <InputField
                  placeholder="Nick"
                  inputLabel="First name"
                  showRequiredIcon
                  autoFocus
                  onChange={(e) => formInstance.setFieldsValue({ firstName: e.target.value })}
                  // onChange={onChange}
                  // onBlur={onBlur}
                  // selected={value}
                  // value={first_name}
                  // {...register("first_name")}
                  // defaultValue="nick"
                  // onChange={setFormData}
                />
              </Form.Item>
              <Form.Item
                name="lastName"
                rules={[
                  { required: false },
                  // exceedCharacterLimitHandler(NAME_EXCEED_LIMIT_MESSAGE),
                ]}
              >
                <InputField placeholder="Fury" inputLabel="Last name" />
              </Form.Item>
            </div>
            <Form.Item
              rules={[
                { required: true, message: EMPTY_REQUIRED_FIELD_MESSAGE },
                // exceedCharacterLimitHandler(COMPANY_NAME_EXCEED_LIMIT_MESSAGE),
              ]}
              name="companyName"
            >
              <InputField
                placeholder="S.H.I.E.L.D"
                inputLabel="Company"
                showRequiredIcon
                onChange={(e) => formInstance.setFieldsValue({ companyName: e.target.value })}
              />
            </Form.Item>
            <Form.Item
              name="email"
              // validateTrigger="onLoad"
              rules={[
                { required: true, message: EMPTY_REQUIRED_FIELD_MESSAGE },
                {
                  type: "email",
                  message: INVALID_EMAIL_MESSAGE,
                },
                // {
                //   validator: (_, value) => {
                //     console.log(_);
                //     Promise.resolve();
                //     // if (formInstance.getFieldError('email').length > 0)
                //     // value.length < 1 && errors.email
                //     //   ? Promise.reject()
                //     //   : Promise.resolve();
                //   },
                // },
              ]}
              // validateTrigger="onMount"

              // validateStatus={
              //   errors.email || formInstance.getFieldError("email").length > 0
              //     ? "error"
              //     : ""
              // }
              // validateStatus="error"
              // help="Should be combination of numbers & alphabets"
              // validateStatus={
              //   formInstance.getFieldError("email").length > 0 || errors.email
              //     ? "error"
              //     : "success"
              // }
              // validateStatus={errors.email ? "error" : "success"}
            >
              <InputField
                placeholder="nickfury@shield.com"
                inputLabel="Email"
                showRequiredIcon
                hasError={errors.email}
                onChange={() => {
                  resetError("email");
                }}
                // {...register("email")}
                // onChange={setFormData}
              />
            </Form.Item>
            <Form.Item name="password" rules={passwordRules}>
              <PasswordField
                placeholder="G00se_took_my_eye"
                inputLabel="password"
                showRequiredIcon
                tagContainerStyle={{ marginBottom: "6px" }}
                // {...register("password")}
                // onChange={setFormData}
              />
            </Form.Item>

            <Form.Item
              name="consent"
              valuePropName="checked"
              // {formInstance.isFieldTouched("consent") && checked === true? "checked" : ""}

              rules={[
                {
                  validator: (_, value) => (value ? Promise.resolve() : Promise.reject(new Error(AGREE_TERMS_AND_CONDITIONS))),
                },
              ]}
            >
              <div className="consent-text-with-checkbox">
                <CheckBox
                  onClick={async (checked) => {
                    formInstance.setFieldsValue({ consent: checked });
                    await formInstance.validateFields(["consent"]);
                  }}
                />
                <span className="consent-text">
                  I understand and agree to the{" "}
                  <u onClick={() => window.open("https://www.getphyllo.com/terms-of-service", "_blank")} style={{ cursor: "pointer" }}>
                    terms of usage
                  </u>{" "}
                  and{" "}
                  <u onClick={() => window.open("https://www.getphyllo.com/privacy-policy", "_blank")} style={{ cursor: "pointer" }}>
                    privacy policy
                  </u>{" "}
                  of Phyllo. I agree to receive email communication (can customize it later).
                </span>
              </div>
            </Form.Item>
            <div className="register-submit-button-container">
              <Form.Item shouldUpdate noStyle>
                {() => (
                  <PrimaryButton
                    disabled={disableSubmit()}
                    label="Register"
                    onClick={onSubmitRegistration}
                    htmlType="submit"
                    style={{
                      width: "156px",
                      marginTop: "12px",
                      marginBottom: "30px",
                    }}
                    loading={loading}
                  />
                )}
              </Form.Item>

              <span className="sign-in-button-text">
                Have an account?{" "}
                <TextLink to="/sign-in" onClick={sendUserAction}>
                  Sign in
                </TextLink>
              </span>
            </div>
          </Form>
        </Card>
      </div>
      <Helmet>
        <title>{getPageTitle("REGISTRATION_PAGE", "")}</title>
        {/* Hubspot initialization only on registration screen */}

        {/* {JSON.parse(process.env.REACT_APP_HUBSPOT_SCRIPT_ENABLED) && (
          <script type="text/javascript" id="hs-script-loader" async defer src="//js.hs-scripts.com/21487726.js"></script>
        )} */}
      </Helmet>
    </Background>
  );
}

const IconListItem = ({ icon, text, ...otherProps }) => {
  return (
    <div className="icon-list-item" {...otherProps}>
      <div className="list-icon-container">{icon}</div>
      <span className="list-item-text">{text}</span>
    </div>
  );
};
